import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PrButtonDropdownComponent } from './pr-button-dropdown.component';
import { PrButtonModule } from '../pr-button/pr-button.module';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  imports: [CommonModule, MatIconModule, PrButtonModule],
  exports: [PrButtonDropdownComponent],
  declarations: [PrButtonDropdownComponent],
})
export class PrButtonDropdownModule {}
